import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import './App.scss';
import NavBar from './components/Nav';
import IceCreamModal from './components/IceCreamModal';
import HomeContainer from './containers/HomeContainer';
// import AboutContainer from './containers/AboutContainer';
import ResumeContainer from './containers/ResumeContainer';
import Contact from './components/contact';


function App() {

  const [show, setShow] = React.useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="App">
      <IceCreamModal show={show} handleClose={handleClose}/> 
      <Router>
        <Route render={routerProps=><NavBar handleShow={handleShow} {...routerProps}  />}/> 
        <Switch>
          <Route exact path="/" component= {HomeContainer} />
          {/* <Route exact path="/about" component= {AboutContainer} /> */}
          <Route exact path="/resume" component= {ResumeContainer} />
          <Route exact path="/contact" component= {Contact} />
        </Switch> 
      </Router>
    </div>
  );
}

export default App;